import { analyticService } from 'global/services';

const addButtonsClickTracker = () => {
    const buttonNodes = document.querySelectorAll('.squidGameContactButton');
    buttonNodes.forEach((node) => {
        node.addEventListener('click', (event) => {
            const { currentTarget: { dataset: { social } } } = event;
            analyticService.push({ eventName: 'Squid_game_Click', buttonName: social });
        });
    });
};

const addBlocksClickTracker = () => {
    const reviewsAreaYaButtonNodes = document.querySelectorAll('.reviewsAreaYaButton');
    reviewsAreaYaButtonNodes.forEach((node) => {
        node.addEventListener('click', () => {
            analyticService.push({ eventName: 'Squid_game_Reviews_Click' });
        });
    });
    const videoBlockRootNode = document.querySelector('.video-slider-root');
    videoBlockRootNode?.addEventListener('click', () => {
        analyticService.push({ eventName: 'Squid_game_Video_Click' });
    });
    const termsLinkNode = document.querySelector('.squidgameTermsLink');
    termsLinkNode?.addEventListener('click', () => {
        analyticService.push({ eventName: 'Squid_game_Terms_Click' });
    });
};

export const dispatchSquidGameEvents = () => {
    addButtonsClickTracker();
    addBlocksClickTracker();
};
